export default "__VITE_ASSET__Cl10pIdu__"